import { Banner, Card, Page, Text } from "@shopify/polaris";

export const UnauthorizedAccess = () => {
  return (
   <Page>
  <Banner tone="critical" title="Your email is already associated with another account" onDismiss={() => {}}>
      <p>Your email is already associated with another store as a staff member. Please login with the email associated with this account.</p>
    </Banner>
   </Page>
  );
};